import CloseIcon from "@mui/icons-material/Close";
import { Edit } from "@mui/icons-material";
import {
  Button,
  Dialog,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { FormEvent, useEffect, useState } from "react";
import {
  ActionByType,
  ProfileDocument,
  ProfileDocumentType,
  ProfileDocumentTypeLabel,
} from "../../common/ProfileDocument";
import { useUpdateProfileDocumentMutation } from "../../redux/api/profileDocument";

interface ProfileDocumentsUpdateModalProps {
  document: ProfileDocument;
  onUpdate: Function;
  actionByType: ActionByType;
}

const ProfileDocumentsUpdateModal = (
  props: ProfileDocumentsUpdateModalProps
) => {
  const [profileDocument, setProfileDocument] = useState<ProfileDocument>(
    props.document
  );
  const [open, setOpen] = useState(false);

  const [updateProfileDocument] = useUpdateProfileDocumentMutation();

  useEffect(() => {
    setProfileDocument({ ...props.document, actionByType: props.actionByType });
  }, [props.document, props.actionByType]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // method to reset form to defaults
  const clearForm = () => {
    setProfileDocument({
      id: 0,
      fileUrl: "",
      fileKey: "",
      contentType: "",
      type: ProfileDocumentType.MMC, // default to MMC
      issueDate: "",
      expirationDate: "",
      displayName: "",
      actionByType: props.actionByType,
    });
  };

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    // TODO: validation
    updateDocument(profileDocument);
  };

  const updateDocument = async (profileDocument: ProfileDocument) => {
    const response = await updateProfileDocument({
      profileDocumentId: props.document.id.toString(),
      profileDocument,
    });

    if ("error" in response === false) {
      handleClose();
      clearForm();
      props.onUpdate();
    }
  };
  return (
    <>
      <Button className="blue-link-button" onClick={handleOpen}>
        <Edit />
        Edit
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        className="modal"
      >
        <div className="modal-header mb-2">
          <Typography id="modal-title" variant="h3">
            Update Document
          </Typography>
          <Button onClick={() => setOpen(false)} className="grey-link-button">
            <CloseIcon />
          </Button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-narrow">
            <div>
              <InputLabel id="typeLabel">Document Type</InputLabel>
              <Select
                labelId="typeLabel"
                id="type"
                value={profileDocument.type}
                label="Document Type"
                onChange={(event) =>
                  setProfileDocument({
                    ...profileDocument,
                    type: event.target.value as ProfileDocumentType,
                  })
                }
              >
                {Object.keys(ProfileDocumentType)
                  .filter((type) => type !== ProfileDocumentType.COVID_VACCINE_CARD &&
                    type !== ProfileDocumentType.TRAINING)
                  .map((type) => (
                    <MenuItem key={type} value={type as ProfileDocumentType}>
                      {ProfileDocumentTypeLabel[type as ProfileDocumentType]}
                    </MenuItem>
                  ))}
              </Select>
            </div>
            <label htmlFor="issueDate">
              <span>Issue Date:</span>
              <input
                type="date"
                id="issueDate"
                value={profileDocument.issueDate}
                onChange={(event) =>
                  setProfileDocument({
                    ...profileDocument,
                    issueDate: event.target.value,
                  })
                }
              />
            </label>
            <label htmlFor="expirationDate">
              <span>Expiration Date:</span>
              <input
                type="date"
                id="expirationDate"
                value={profileDocument.expirationDate}
                onChange={(event) =>
                  setProfileDocument({
                    ...profileDocument,
                    expirationDate: event.target.value,
                  })
                }
              />
            </label>
          </div>
          <input
            type="submit"
            value="Update Document"
            className="blue-button-small modal-button"
          />
        </form>
      </Dialog>
    </>
  );
};

export default ProfileDocumentsUpdateModal;
